import UserInfoPopover from './UserInfoPopover';
export default UserInfoPopover;
